import { chakra, useToken } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';

const tilePulse = keyframes`
  0% { opacity: 0.2; transform: translateY(0); }
  25% { opacity: 1; transform: translateY(-16px); }
  50% { opacity: 0.5; transform: translateY(0); }
  100% { opacity: 0.2; transform: translateY(0); }
`;


type FaceliftSquaresLoadingIndicatorProps = {
  width?: number;
};

export const FaceliftSquaresLoadingIndicator = ({ width: desiredWidth }: FaceliftSquaresLoadingIndicatorProps) => {
  const loaderPalette = useToken('colors', ['loader1', 'loader2', 'loader3', 'loader4', 'loader5']);


  const tile = 28;
  const gap = 4;

  const tileCount = loaderPalette.length;
  const tileSpacing = tile + gap;
  const baseWidth = tile * tileCount + gap * (tileCount - 1);
  const baseHeight = tile * 1.6;
  const minWidth = 215;
  const minHeight = 68;
  const aspectRatio = baseHeight / baseWidth;
  const computedWidth = Math.max(desiredWidth ?? minWidth, minWidth);
  const computedHeight = Math.max(computedWidth * aspectRatio, minHeight);
  const animationDuration = `1400ms`;

  return (
    <chakra.svg width={computedWidth} height={computedHeight} viewBox={`0 0 ${baseWidth} ${baseHeight}`} aria-hidden="true">
      {loaderPalette.map((fill, index) => (
        <chakra.rect
          key={`${index}-${fill}`}
          x={`${index * tileSpacing}`}
          y={`${baseHeight - tile}`}
          width={`${tile}`}
          height={`${tile}`}
          rx="4"
          fill={fill}
          css={{
            animation: `${tilePulse} ${animationDuration} ease-in-out ${index * 0.15}s infinite`,
          }}
        />
      ))}
    </chakra.svg>

  );
};
